// source: pangolin/protos/vpnserver.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */


var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.pangolin.protos.VPNServerHedgehogClientGetResponse', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerHedgehogClientListResponse', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerHedgehogClientObject', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerHedgehogClientObjectMap', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerPangolinClientConnectError', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerPangolinClientConnectObject', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerPangolinClientConnectRequest', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerPangolinClientConnectResponse', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerPangolinClientConnectResponseInvalid', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError.VPNConfigCase', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject.VPNConfigCase', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerPangolinClientConnectedError', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerPangolinClientConnectedObject', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerPangolinClientConnectedRequest', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerPangolinClientConnectedResponseInvalid', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerPangolinClientCreateRequest', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerPangolinClientCreateResponse', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerPangolinClientGetResponse', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerPangolinClientListResponse', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerPangolinClientObject', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerPangolinClientObjectMap', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerPangolinClientUpdateRequest', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerPangolinClientUpdateResponse', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerPangolinClientVPNConfigObject', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerPangolinNetworkProtocol', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerPangolinPunchMode', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerPangolinServerConnectObject', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject.VPNConfigCase', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerPangolinServerError', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerPangolinServerGetResponse', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerPangolinServerObject', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerPangolinServerSetRequest', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerPangolinServerSetResponseInvalid', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerPangolinStatus', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerPangolinVPNProtocol', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerWireguardClientConnectError', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerWireguardClientConnectObject', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerWireguardClientObject', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerWireguardServerConnectObject', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerWireguardServerError', null, global);
goog.exportSymbol('proto.pangolin.protos.VPNServerWireguardServerObject', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerWireguardServerObject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.VPNServerWireguardServerObject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerWireguardServerObject.displayName = 'proto.pangolin.protos.VPNServerWireguardServerObject';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerWireguardServerError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pangolin.protos.VPNServerWireguardServerError.repeatedFields_, null);
};
goog.inherits(proto.pangolin.protos.VPNServerWireguardServerError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerWireguardServerError.displayName = 'proto.pangolin.protos.VPNServerWireguardServerError';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerWireguardClientObject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.VPNServerWireguardClientObject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerWireguardClientObject.displayName = 'proto.pangolin.protos.VPNServerWireguardClientObject';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerWireguardClientConnectObject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.VPNServerWireguardClientConnectObject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerWireguardClientConnectObject.displayName = 'proto.pangolin.protos.VPNServerWireguardClientConnectObject';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerWireguardClientConnectError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pangolin.protos.VPNServerWireguardClientConnectError.repeatedFields_, null);
};
goog.inherits(proto.pangolin.protos.VPNServerWireguardClientConnectError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerWireguardClientConnectError.displayName = 'proto.pangolin.protos.VPNServerWireguardClientConnectError';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerWireguardServerConnectObject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pangolin.protos.VPNServerWireguardServerConnectObject.repeatedFields_, null);
};
goog.inherits(proto.pangolin.protos.VPNServerWireguardServerConnectObject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerWireguardServerConnectObject.displayName = 'proto.pangolin.protos.VPNServerWireguardServerConnectObject';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerHedgehogClientObject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.VPNServerHedgehogClientObject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerHedgehogClientObject.displayName = 'proto.pangolin.protos.VPNServerHedgehogClientObject';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerHedgehogClientObjectMap = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pangolin.protos.VPNServerHedgehogClientObjectMap.repeatedFields_, null);
};
goog.inherits(proto.pangolin.protos.VPNServerHedgehogClientObjectMap, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerHedgehogClientObjectMap.displayName = 'proto.pangolin.protos.VPNServerHedgehogClientObjectMap';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple.displayName = 'proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerPangolinClientVPNConfigObject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.VPNServerPangolinClientVPNConfigObject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerPangolinClientVPNConfigObject.displayName = 'proto.pangolin.protos.VPNServerPangolinClientVPNConfigObject';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerPangolinServerObject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.VPNServerPangolinServerObject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerPangolinServerObject.displayName = 'proto.pangolin.protos.VPNServerPangolinServerObject';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerPangolinServerError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pangolin.protos.VPNServerPangolinServerError.repeatedFields_, null);
};
goog.inherits(proto.pangolin.protos.VPNServerPangolinServerError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerPangolinServerError.displayName = 'proto.pangolin.protos.VPNServerPangolinServerError';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerPangolinClientObject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.VPNServerPangolinClientObject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerPangolinClientObject.displayName = 'proto.pangolin.protos.VPNServerPangolinClientObject';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerPangolinClientObjectMap = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pangolin.protos.VPNServerPangolinClientObjectMap.repeatedFields_, null);
};
goog.inherits(proto.pangolin.protos.VPNServerPangolinClientObjectMap, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerPangolinClientObjectMap.displayName = 'proto.pangolin.protos.VPNServerPangolinClientObjectMap';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple.displayName = 'proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject.oneofGroups_);
};
goog.inherits(proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject.displayName = 'proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError.oneofGroups_);
};
goog.inherits(proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError.displayName = 'proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject.oneofGroups_);
};
goog.inherits(proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject.displayName = 'proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerPangolinClientConnectObject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.VPNServerPangolinClientConnectObject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerPangolinClientConnectObject.displayName = 'proto.pangolin.protos.VPNServerPangolinClientConnectObject';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerPangolinClientConnectError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pangolin.protos.VPNServerPangolinClientConnectError.repeatedFields_, null);
};
goog.inherits(proto.pangolin.protos.VPNServerPangolinClientConnectError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerPangolinClientConnectError.displayName = 'proto.pangolin.protos.VPNServerPangolinClientConnectError';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerPangolinServerConnectObject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.VPNServerPangolinServerConnectObject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerPangolinServerConnectObject.displayName = 'proto.pangolin.protos.VPNServerPangolinServerConnectObject';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedObject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.VPNServerPangolinClientConnectedObject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerPangolinClientConnectedObject.displayName = 'proto.pangolin.protos.VPNServerPangolinClientConnectedObject';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pangolin.protos.VPNServerPangolinClientConnectedError.repeatedFields_, null);
};
goog.inherits(proto.pangolin.protos.VPNServerPangolinClientConnectedError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerPangolinClientConnectedError.displayName = 'proto.pangolin.protos.VPNServerPangolinClientConnectedError';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerHedgehogClientListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.VPNServerHedgehogClientListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerHedgehogClientListResponse.displayName = 'proto.pangolin.protos.VPNServerHedgehogClientListResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerHedgehogClientGetResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.VPNServerHedgehogClientGetResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerHedgehogClientGetResponse.displayName = 'proto.pangolin.protos.VPNServerHedgehogClientGetResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerPangolinServerGetResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.VPNServerPangolinServerGetResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerPangolinServerGetResponse.displayName = 'proto.pangolin.protos.VPNServerPangolinServerGetResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerPangolinServerSetRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.VPNServerPangolinServerSetRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerPangolinServerSetRequest.displayName = 'proto.pangolin.protos.VPNServerPangolinServerSetRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerPangolinServerSetResponseInvalid = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.VPNServerPangolinServerSetResponseInvalid, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerPangolinServerSetResponseInvalid.displayName = 'proto.pangolin.protos.VPNServerPangolinServerSetResponseInvalid';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerPangolinClientListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.VPNServerPangolinClientListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerPangolinClientListResponse.displayName = 'proto.pangolin.protos.VPNServerPangolinClientListResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerPangolinClientGetResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.VPNServerPangolinClientGetResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerPangolinClientGetResponse.displayName = 'proto.pangolin.protos.VPNServerPangolinClientGetResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerPangolinClientCreateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.VPNServerPangolinClientCreateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerPangolinClientCreateRequest.displayName = 'proto.pangolin.protos.VPNServerPangolinClientCreateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerPangolinClientCreateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.VPNServerPangolinClientCreateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerPangolinClientCreateResponse.displayName = 'proto.pangolin.protos.VPNServerPangolinClientCreateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerPangolinClientUpdateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.VPNServerPangolinClientUpdateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerPangolinClientUpdateRequest.displayName = 'proto.pangolin.protos.VPNServerPangolinClientUpdateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerPangolinClientUpdateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.VPNServerPangolinClientUpdateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerPangolinClientUpdateResponse.displayName = 'proto.pangolin.protos.VPNServerPangolinClientUpdateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerPangolinClientConnectRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.VPNServerPangolinClientConnectRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerPangolinClientConnectRequest.displayName = 'proto.pangolin.protos.VPNServerPangolinClientConnectRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerPangolinClientConnectResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.VPNServerPangolinClientConnectResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerPangolinClientConnectResponse.displayName = 'proto.pangolin.protos.VPNServerPangolinClientConnectResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerPangolinClientConnectResponseInvalid = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.VPNServerPangolinClientConnectResponseInvalid, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerPangolinClientConnectResponseInvalid.displayName = 'proto.pangolin.protos.VPNServerPangolinClientConnectResponseInvalid';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.VPNServerPangolinClientConnectedRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerPangolinClientConnectedRequest.displayName = 'proto.pangolin.protos.VPNServerPangolinClientConnectedRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedResponseInvalid = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.VPNServerPangolinClientConnectedResponseInvalid, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.VPNServerPangolinClientConnectedResponseInvalid.displayName = 'proto.pangolin.protos.VPNServerPangolinClientConnectedResponseInvalid';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerWireguardServerObject.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerWireguardServerObject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerWireguardServerObject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerWireguardServerObject.toObject = function(includeInstance, msg) {
  var f, obj = {
    publicKey: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerWireguardServerObject}
 */
proto.pangolin.protos.VPNServerWireguardServerObject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerWireguardServerObject;
  return proto.pangolin.protos.VPNServerWireguardServerObject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerWireguardServerObject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerWireguardServerObject}
 */
proto.pangolin.protos.VPNServerWireguardServerObject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPublicKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerWireguardServerObject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerWireguardServerObject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerWireguardServerObject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerWireguardServerObject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string public_key = 1;
 * @return {string}
 */
proto.pangolin.protos.VPNServerWireguardServerObject.prototype.getPublicKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.VPNServerWireguardServerObject} returns this
 */
proto.pangolin.protos.VPNServerWireguardServerObject.prototype.setPublicKey = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerWireguardServerObject} returns this
 */
proto.pangolin.protos.VPNServerWireguardServerObject.prototype.clearPublicKey = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerWireguardServerObject.prototype.hasPublicKey = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pangolin.protos.VPNServerWireguardServerError.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerWireguardServerError.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerWireguardServerError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerWireguardServerError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerWireguardServerError.toObject = function(includeInstance, msg) {
  var f, obj = {
    publicKeyList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerWireguardServerError}
 */
proto.pangolin.protos.VPNServerWireguardServerError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerWireguardServerError;
  return proto.pangolin.protos.VPNServerWireguardServerError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerWireguardServerError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerWireguardServerError}
 */
proto.pangolin.protos.VPNServerWireguardServerError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addPublicKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerWireguardServerError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerWireguardServerError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerWireguardServerError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerWireguardServerError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPublicKeyList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string public_key = 1;
 * @return {!Array<string>}
 */
proto.pangolin.protos.VPNServerWireguardServerError.prototype.getPublicKeyList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.VPNServerWireguardServerError} returns this
 */
proto.pangolin.protos.VPNServerWireguardServerError.prototype.setPublicKeyList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.VPNServerWireguardServerError} returns this
 */
proto.pangolin.protos.VPNServerWireguardServerError.prototype.addPublicKey = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.VPNServerWireguardServerError} returns this
 */
proto.pangolin.protos.VPNServerWireguardServerError.prototype.clearPublicKeyList = function() {
  return this.setPublicKeyList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerWireguardClientObject.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerWireguardClientObject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerWireguardClientObject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerWireguardClientObject.toObject = function(includeInstance, msg) {
  var f, obj = {
    publicKey: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerWireguardClientObject}
 */
proto.pangolin.protos.VPNServerWireguardClientObject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerWireguardClientObject;
  return proto.pangolin.protos.VPNServerWireguardClientObject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerWireguardClientObject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerWireguardClientObject}
 */
proto.pangolin.protos.VPNServerWireguardClientObject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPublicKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerWireguardClientObject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerWireguardClientObject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerWireguardClientObject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerWireguardClientObject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string public_key = 1;
 * @return {string}
 */
proto.pangolin.protos.VPNServerWireguardClientObject.prototype.getPublicKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.VPNServerWireguardClientObject} returns this
 */
proto.pangolin.protos.VPNServerWireguardClientObject.prototype.setPublicKey = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerWireguardClientObject} returns this
 */
proto.pangolin.protos.VPNServerWireguardClientObject.prototype.clearPublicKey = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerWireguardClientObject.prototype.hasPublicKey = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerWireguardClientConnectObject.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerWireguardClientConnectObject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerWireguardClientConnectObject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerWireguardClientConnectObject.toObject = function(includeInstance, msg) {
  var f, obj = {
    publicKey: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerWireguardClientConnectObject}
 */
proto.pangolin.protos.VPNServerWireguardClientConnectObject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerWireguardClientConnectObject;
  return proto.pangolin.protos.VPNServerWireguardClientConnectObject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerWireguardClientConnectObject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerWireguardClientConnectObject}
 */
proto.pangolin.protos.VPNServerWireguardClientConnectObject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPublicKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerWireguardClientConnectObject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerWireguardClientConnectObject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerWireguardClientConnectObject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerWireguardClientConnectObject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string public_key = 1;
 * @return {string}
 */
proto.pangolin.protos.VPNServerWireguardClientConnectObject.prototype.getPublicKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.VPNServerWireguardClientConnectObject} returns this
 */
proto.pangolin.protos.VPNServerWireguardClientConnectObject.prototype.setPublicKey = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerWireguardClientConnectObject} returns this
 */
proto.pangolin.protos.VPNServerWireguardClientConnectObject.prototype.clearPublicKey = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerWireguardClientConnectObject.prototype.hasPublicKey = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pangolin.protos.VPNServerWireguardClientConnectError.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerWireguardClientConnectError.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerWireguardClientConnectError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerWireguardClientConnectError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerWireguardClientConnectError.toObject = function(includeInstance, msg) {
  var f, obj = {
    publicKeyList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerWireguardClientConnectError}
 */
proto.pangolin.protos.VPNServerWireguardClientConnectError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerWireguardClientConnectError;
  return proto.pangolin.protos.VPNServerWireguardClientConnectError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerWireguardClientConnectError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerWireguardClientConnectError}
 */
proto.pangolin.protos.VPNServerWireguardClientConnectError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addPublicKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerWireguardClientConnectError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerWireguardClientConnectError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerWireguardClientConnectError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerWireguardClientConnectError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPublicKeyList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string public_key = 1;
 * @return {!Array<string>}
 */
proto.pangolin.protos.VPNServerWireguardClientConnectError.prototype.getPublicKeyList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.VPNServerWireguardClientConnectError} returns this
 */
proto.pangolin.protos.VPNServerWireguardClientConnectError.prototype.setPublicKeyList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.VPNServerWireguardClientConnectError} returns this
 */
proto.pangolin.protos.VPNServerWireguardClientConnectError.prototype.addPublicKey = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.VPNServerWireguardClientConnectError} returns this
 */
proto.pangolin.protos.VPNServerWireguardClientConnectError.prototype.clearPublicKeyList = function() {
  return this.setPublicKeyList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pangolin.protos.VPNServerWireguardServerConnectObject.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerWireguardServerConnectObject.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerWireguardServerConnectObject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerWireguardServerConnectObject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerWireguardServerConnectObject.toObject = function(includeInstance, msg) {
  var f, obj = {
    publicKey: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    clientIp: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    clientNsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerWireguardServerConnectObject}
 */
proto.pangolin.protos.VPNServerWireguardServerConnectObject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerWireguardServerConnectObject;
  return proto.pangolin.protos.VPNServerWireguardServerConnectObject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerWireguardServerConnectObject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerWireguardServerConnectObject}
 */
proto.pangolin.protos.VPNServerWireguardServerConnectObject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPublicKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientIp(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addClientNs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerWireguardServerConnectObject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerWireguardServerConnectObject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerWireguardServerConnectObject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerWireguardServerConnectObject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getClientNsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional string public_key = 1;
 * @return {string}
 */
proto.pangolin.protos.VPNServerWireguardServerConnectObject.prototype.getPublicKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.VPNServerWireguardServerConnectObject} returns this
 */
proto.pangolin.protos.VPNServerWireguardServerConnectObject.prototype.setPublicKey = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerWireguardServerConnectObject} returns this
 */
proto.pangolin.protos.VPNServerWireguardServerConnectObject.prototype.clearPublicKey = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerWireguardServerConnectObject.prototype.hasPublicKey = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string client_ip = 2;
 * @return {string}
 */
proto.pangolin.protos.VPNServerWireguardServerConnectObject.prototype.getClientIp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.VPNServerWireguardServerConnectObject} returns this
 */
proto.pangolin.protos.VPNServerWireguardServerConnectObject.prototype.setClientIp = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerWireguardServerConnectObject} returns this
 */
proto.pangolin.protos.VPNServerWireguardServerConnectObject.prototype.clearClientIp = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerWireguardServerConnectObject.prototype.hasClientIp = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated string client_ns = 3;
 * @return {!Array<string>}
 */
proto.pangolin.protos.VPNServerWireguardServerConnectObject.prototype.getClientNsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.VPNServerWireguardServerConnectObject} returns this
 */
proto.pangolin.protos.VPNServerWireguardServerConnectObject.prototype.setClientNsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.VPNServerWireguardServerConnectObject} returns this
 */
proto.pangolin.protos.VPNServerWireguardServerConnectObject.prototype.addClientNs = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.VPNServerWireguardServerConnectObject} returns this
 */
proto.pangolin.protos.VPNServerWireguardServerConnectObject.prototype.clearClientNsList = function() {
  return this.setClientNsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerHedgehogClientObject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerHedgehogClientObject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    nonce: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    name: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
    isEnabled: (f = jspb.Message.getBooleanField(msg, 4)) == null ? undefined : f,
    isClaimed: (f = jspb.Message.getBooleanField(msg, 5)) == null ? undefined : f,
    claimedAt: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
    createdAt: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
    updatedAt: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientObject}
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerHedgehogClientObject;
  return proto.pangolin.protos.VPNServerHedgehogClientObject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerHedgehogClientObject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientObject}
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNonce(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsEnabled(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsClaimed(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setClaimedAt(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedAt(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerHedgehogClientObject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerHedgehogClientObject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeBool(
      4,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeBool(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientObject} returns this
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientObject} returns this
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string nonce = 2;
 * @return {string}
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.prototype.getNonce = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientObject} returns this
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.prototype.setNonce = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientObject} returns this
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.prototype.clearNonce = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.prototype.hasNonce = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientObject} returns this
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.prototype.setName = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientObject} returns this
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.prototype.clearName = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.prototype.hasName = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool is_enabled = 4;
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.prototype.getIsEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientObject} returns this
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.prototype.setIsEnabled = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientObject} returns this
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.prototype.clearIsEnabled = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.prototype.hasIsEnabled = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional bool is_claimed = 5;
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.prototype.getIsClaimed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientObject} returns this
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.prototype.setIsClaimed = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientObject} returns this
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.prototype.clearIsClaimed = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.prototype.hasIsClaimed = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string claimed_at = 6;
 * @return {string}
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.prototype.getClaimedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientObject} returns this
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.prototype.setClaimedAt = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientObject} returns this
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.prototype.clearClaimedAt = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.prototype.hasClaimedAt = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string created_at = 7;
 * @return {string}
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.prototype.getCreatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientObject} returns this
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.prototype.setCreatedAt = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientObject} returns this
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.prototype.clearCreatedAt = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string updated_at = 8;
 * @return {string}
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.prototype.getUpdatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientObject} returns this
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientObject} returns this
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.prototype.clearUpdatedAt = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerHedgehogClientObject.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 8) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pangolin.protos.VPNServerHedgehogClientObjectMap.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerHedgehogClientObjectMap.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerHedgehogClientObjectMap.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerHedgehogClientObjectMap} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerHedgehogClientObjectMap.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientObjectMap}
 */
proto.pangolin.protos.VPNServerHedgehogClientObjectMap.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerHedgehogClientObjectMap;
  return proto.pangolin.protos.VPNServerHedgehogClientObjectMap.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerHedgehogClientObjectMap} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientObjectMap}
 */
proto.pangolin.protos.VPNServerHedgehogClientObjectMap.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple;
      reader.readMessage(value,proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerHedgehogClientObjectMap.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerHedgehogClientObjectMap.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerHedgehogClientObjectMap} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerHedgehogClientObjectMap.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple.serializeBinaryToWriter
    );
  }
};


/**
 * repeated VPNServerHedgehogClientObjectMapTuple items = 1;
 * @return {!Array<!proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple>}
 */
proto.pangolin.protos.VPNServerHedgehogClientObjectMap.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple, 1));
};


/**
 * @param {!Array<!proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple>} value
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientObjectMap} returns this
*/
proto.pangolin.protos.VPNServerHedgehogClientObjectMap.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple}
 */
proto.pangolin.protos.VPNServerHedgehogClientObjectMap.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientObjectMap} returns this
 */
proto.pangolin.protos.VPNServerHedgehogClientObjectMap.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    data: (f = msg.getData()) && proto.pangolin.protos.VPNServerHedgehogClientObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple}
 */
proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple;
  return proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple}
 */
proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.pangolin.protos.VPNServerHedgehogClientObject;
      reader.readMessage(value,proto.pangolin.protos.VPNServerHedgehogClientObject.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pangolin.protos.VPNServerHedgehogClientObject.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple} returns this
 */
proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple} returns this
 */
proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional VPNServerHedgehogClientObject data = 2;
 * @return {?proto.pangolin.protos.VPNServerHedgehogClientObject}
 */
proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple.prototype.getData = function() {
  return /** @type{?proto.pangolin.protos.VPNServerHedgehogClientObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.VPNServerHedgehogClientObject, 2));
};


/**
 * @param {?proto.pangolin.protos.VPNServerHedgehogClientObject|undefined} value
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple} returns this
*/
proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple} returns this
 */
proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerHedgehogClientObjectMapTuple.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerPangolinClientVPNConfigObject.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerPangolinClientVPNConfigObject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerPangolinClientVPNConfigObject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientVPNConfigObject.toObject = function(includeInstance, msg) {
  var f, obj = {
    wireguard: (f = msg.getWireguard()) && proto.pangolin.protos.VPNServerWireguardClientObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientVPNConfigObject}
 */
proto.pangolin.protos.VPNServerPangolinClientVPNConfigObject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerPangolinClientVPNConfigObject;
  return proto.pangolin.protos.VPNServerPangolinClientVPNConfigObject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientVPNConfigObject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientVPNConfigObject}
 */
proto.pangolin.protos.VPNServerPangolinClientVPNConfigObject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.VPNServerWireguardClientObject;
      reader.readMessage(value,proto.pangolin.protos.VPNServerWireguardClientObject.deserializeBinaryFromReader);
      msg.setWireguard(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerPangolinClientVPNConfigObject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerPangolinClientVPNConfigObject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientVPNConfigObject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientVPNConfigObject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWireguard();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.VPNServerWireguardClientObject.serializeBinaryToWriter
    );
  }
};


/**
 * optional VPNServerWireguardClientObject wireguard = 1;
 * @return {?proto.pangolin.protos.VPNServerWireguardClientObject}
 */
proto.pangolin.protos.VPNServerPangolinClientVPNConfigObject.prototype.getWireguard = function() {
  return /** @type{?proto.pangolin.protos.VPNServerWireguardClientObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.VPNServerWireguardClientObject, 1));
};


/**
 * @param {?proto.pangolin.protos.VPNServerWireguardClientObject|undefined} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientVPNConfigObject} returns this
*/
proto.pangolin.protos.VPNServerPangolinClientVPNConfigObject.prototype.setWireguard = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientVPNConfigObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientVPNConfigObject.prototype.clearWireguard = function() {
  return this.setWireguard(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinClientVPNConfigObject.prototype.hasWireguard = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerPangolinServerObject.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerPangolinServerObject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerPangolinServerObject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinServerObject.toObject = function(includeInstance, msg) {
  var f, obj = {
    isEnabled: (f = jspb.Message.getBooleanField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerPangolinServerObject}
 */
proto.pangolin.protos.VPNServerPangolinServerObject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerPangolinServerObject;
  return proto.pangolin.protos.VPNServerPangolinServerObject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerPangolinServerObject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerPangolinServerObject}
 */
proto.pangolin.protos.VPNServerPangolinServerObject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsEnabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerPangolinServerObject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerPangolinServerObject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerPangolinServerObject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinServerObject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {boolean} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool is_enabled = 1;
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinServerObject.prototype.getIsEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pangolin.protos.VPNServerPangolinServerObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinServerObject.prototype.setIsEnabled = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinServerObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinServerObject.prototype.clearIsEnabled = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinServerObject.prototype.hasIsEnabled = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pangolin.protos.VPNServerPangolinServerError.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerPangolinServerError.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerPangolinServerError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerPangolinServerError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinServerError.toObject = function(includeInstance, msg) {
  var f, obj = {
    isEnabledList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerPangolinServerError}
 */
proto.pangolin.protos.VPNServerPangolinServerError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerPangolinServerError;
  return proto.pangolin.protos.VPNServerPangolinServerError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerPangolinServerError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerPangolinServerError}
 */
proto.pangolin.protos.VPNServerPangolinServerError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addIsEnabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerPangolinServerError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerPangolinServerError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerPangolinServerError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinServerError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsEnabledList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string is_enabled = 1;
 * @return {!Array<string>}
 */
proto.pangolin.protos.VPNServerPangolinServerError.prototype.getIsEnabledList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.VPNServerPangolinServerError} returns this
 */
proto.pangolin.protos.VPNServerPangolinServerError.prototype.setIsEnabledList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.VPNServerPangolinServerError} returns this
 */
proto.pangolin.protos.VPNServerPangolinServerError.prototype.addIsEnabled = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.VPNServerPangolinServerError} returns this
 */
proto.pangolin.protos.VPNServerPangolinServerError.prototype.clearIsEnabledList = function() {
  return this.setIsEnabledList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerPangolinClientObject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerPangolinClientObject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientObject.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    punchMode: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    vpnProto: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
    netProto: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
    publicIp: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
    publicPort: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
    lastSeen: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
    hostId: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f,
    status: (f = jspb.Message.getField(msg, 9)) == null ? undefined : f,
    vpnConfig: (f = msg.getVPNConfig()) && proto.pangolin.protos.VPNServerPangolinClientVPNConfigObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObject}
 */
proto.pangolin.protos.VPNServerPangolinClientObject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerPangolinClientObject;
  return proto.pangolin.protos.VPNServerPangolinClientObject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientObject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObject}
 */
proto.pangolin.protos.VPNServerPangolinClientObject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.pangolin.protos.VPNServerPangolinPunchMode} */ (reader.readEnum());
      msg.setPunchMode(value);
      break;
    case 3:
      var value = /** @type {!proto.pangolin.protos.VPNServerPangolinVPNProtocol} */ (reader.readEnum());
      msg.setVPNProto(value);
      break;
    case 4:
      var value = /** @type {!proto.pangolin.protos.VPNServerPangolinNetworkProtocol} */ (reader.readEnum());
      msg.setNetProto(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPublicIp(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPublicPort(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastSeen(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setHostId(value);
      break;
    case 9:
      var value = /** @type {!proto.pangolin.protos.VPNServerPangolinStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 10:
      var value = new proto.pangolin.protos.VPNServerPangolinClientVPNConfigObject;
      reader.readMessage(value,proto.pangolin.protos.VPNServerPangolinClientVPNConfigObject.deserializeBinaryFromReader);
      msg.setVPNConfig(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerPangolinClientObject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientObject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientObject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {!proto.pangolin.protos.VPNServerPangolinPunchMode} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = /** @type {!proto.pangolin.protos.VPNServerPangolinVPNProtocol} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = /** @type {!proto.pangolin.protos.VPNServerPangolinNetworkProtocol} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeString(
      8,
      f
    );
  }
  f = /** @type {!proto.pangolin.protos.VPNServerPangolinStatus} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getVPNConfig();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.pangolin.protos.VPNServerPangolinClientVPNConfigObject.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional VPNServerPangolinPunchMode punch_mode = 2;
 * @return {!proto.pangolin.protos.VPNServerPangolinPunchMode}
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.getPunchMode = function() {
  return /** @type {!proto.pangolin.protos.VPNServerPangolinPunchMode} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.pangolin.protos.VPNServerPangolinPunchMode} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.setPunchMode = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.clearPunchMode = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.hasPunchMode = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional VPNServerPangolinVPNProtocol vpn_proto = 3;
 * @return {!proto.pangolin.protos.VPNServerPangolinVPNProtocol}
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.getVPNProto = function() {
  return /** @type {!proto.pangolin.protos.VPNServerPangolinVPNProtocol} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.pangolin.protos.VPNServerPangolinVPNProtocol} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.setVPNProto = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.clearVPNProto = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.hasVPNProto = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional VPNServerPangolinNetworkProtocol net_proto = 4;
 * @return {!proto.pangolin.protos.VPNServerPangolinNetworkProtocol}
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.getNetProto = function() {
  return /** @type {!proto.pangolin.protos.VPNServerPangolinNetworkProtocol} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.pangolin.protos.VPNServerPangolinNetworkProtocol} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.setNetProto = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.clearNetProto = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.hasNetProto = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string public_ip = 5;
 * @return {string}
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.getPublicIp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.setPublicIp = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.clearPublicIp = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.hasPublicIp = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional uint32 public_port = 6;
 * @return {number}
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.getPublicPort = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.setPublicPort = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.clearPublicPort = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.hasPublicPort = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string last_seen = 7;
 * @return {string}
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.getLastSeen = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.setLastSeen = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.clearLastSeen = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.hasLastSeen = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string host_id = 8;
 * @return {string}
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.getHostId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.setHostId = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.clearHostId = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.hasHostId = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional VPNServerPangolinStatus status = 9;
 * @return {!proto.pangolin.protos.VPNServerPangolinStatus}
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.getStatus = function() {
  return /** @type {!proto.pangolin.protos.VPNServerPangolinStatus} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.pangolin.protos.VPNServerPangolinStatus} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.setStatus = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.clearStatus = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional VPNServerPangolinClientVPNConfigObject vpn_config = 10;
 * @return {?proto.pangolin.protos.VPNServerPangolinClientVPNConfigObject}
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.getVPNConfig = function() {
  return /** @type{?proto.pangolin.protos.VPNServerPangolinClientVPNConfigObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.VPNServerPangolinClientVPNConfigObject, 10));
};


/**
 * @param {?proto.pangolin.protos.VPNServerPangolinClientVPNConfigObject|undefined} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObject} returns this
*/
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.setVPNConfig = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.clearVPNConfig = function() {
  return this.setVPNConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinClientObject.prototype.hasVPNConfig = function() {
  return jspb.Message.getField(this, 10) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pangolin.protos.VPNServerPangolinClientObjectMap.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerPangolinClientObjectMap.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerPangolinClientObjectMap.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerPangolinClientObjectMap} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientObjectMap.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObjectMap}
 */
proto.pangolin.protos.VPNServerPangolinClientObjectMap.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerPangolinClientObjectMap;
  return proto.pangolin.protos.VPNServerPangolinClientObjectMap.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientObjectMap} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObjectMap}
 */
proto.pangolin.protos.VPNServerPangolinClientObjectMap.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple;
      reader.readMessage(value,proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerPangolinClientObjectMap.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerPangolinClientObjectMap.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientObjectMap} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientObjectMap.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple.serializeBinaryToWriter
    );
  }
};


/**
 * repeated VPNServerPangolinClientObjectMapTuple items = 1;
 * @return {!Array<!proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple>}
 */
proto.pangolin.protos.VPNServerPangolinClientObjectMap.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple, 1));
};


/**
 * @param {!Array<!proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple>} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObjectMap} returns this
*/
proto.pangolin.protos.VPNServerPangolinClientObjectMap.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple}
 */
proto.pangolin.protos.VPNServerPangolinClientObjectMap.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObjectMap} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientObjectMap.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    data: (f = msg.getData()) && proto.pangolin.protos.VPNServerPangolinClientObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple}
 */
proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple;
  return proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple}
 */
proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.pangolin.protos.VPNServerPangolinClientObject;
      reader.readMessage(value,proto.pangolin.protos.VPNServerPangolinClientObject.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pangolin.protos.VPNServerPangolinClientObject.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional VPNServerPangolinClientObject data = 2;
 * @return {?proto.pangolin.protos.VPNServerPangolinClientObject}
 */
proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple.prototype.getData = function() {
  return /** @type{?proto.pangolin.protos.VPNServerPangolinClientObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.VPNServerPangolinClientObject, 2));
};


/**
 * @param {?proto.pangolin.protos.VPNServerPangolinClientObject|undefined} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple} returns this
*/
proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinClientObjectMapTuple.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject.oneofGroups_ = [[1]];

/**
 * @enum {number}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject.VPNConfigCase = {
  VPN_CONFIG_NOT_SET: 0,
  WIREGUARD: 1
};

/**
 * @return {proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject.VPNConfigCase}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject.prototype.getVPNConfigCase = function() {
  return /** @type {proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject.VPNConfigCase} */(jspb.Message.computeOneofCase(this, proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject.toObject = function(includeInstance, msg) {
  var f, obj = {
    wireguard: (f = msg.getWireguard()) && proto.pangolin.protos.VPNServerWireguardClientConnectObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject;
  return proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.VPNServerWireguardClientConnectObject;
      reader.readMessage(value,proto.pangolin.protos.VPNServerWireguardClientConnectObject.deserializeBinaryFromReader);
      msg.setWireguard(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWireguard();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.VPNServerWireguardClientConnectObject.serializeBinaryToWriter
    );
  }
};


/**
 * optional VPNServerWireguardClientConnectObject wireguard = 1;
 * @return {?proto.pangolin.protos.VPNServerWireguardClientConnectObject}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject.prototype.getWireguard = function() {
  return /** @type{?proto.pangolin.protos.VPNServerWireguardClientConnectObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.VPNServerWireguardClientConnectObject, 1));
};


/**
 * @param {?proto.pangolin.protos.VPNServerWireguardClientConnectObject|undefined} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject} returns this
*/
proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject.prototype.setWireguard = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject.prototype.clearWireguard = function() {
  return this.setWireguard(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject.prototype.hasWireguard = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError.oneofGroups_ = [[1]];

/**
 * @enum {number}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError.VPNConfigCase = {
  VPN_CONFIG_NOT_SET: 0,
  WIREGUARD: 1
};

/**
 * @return {proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError.VPNConfigCase}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError.prototype.getVPNConfigCase = function() {
  return /** @type {proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError.VPNConfigCase} */(jspb.Message.computeOneofCase(this, proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError.toObject = function(includeInstance, msg) {
  var f, obj = {
    wireguard: (f = msg.getWireguard()) && proto.pangolin.protos.VPNServerWireguardClientConnectError.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError;
  return proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.VPNServerWireguardClientConnectError;
      reader.readMessage(value,proto.pangolin.protos.VPNServerWireguardClientConnectError.deserializeBinaryFromReader);
      msg.setWireguard(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWireguard();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.VPNServerWireguardClientConnectError.serializeBinaryToWriter
    );
  }
};


/**
 * optional VPNServerWireguardClientConnectError wireguard = 1;
 * @return {?proto.pangolin.protos.VPNServerWireguardClientConnectError}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError.prototype.getWireguard = function() {
  return /** @type{?proto.pangolin.protos.VPNServerWireguardClientConnectError} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.VPNServerWireguardClientConnectError, 1));
};


/**
 * @param {?proto.pangolin.protos.VPNServerWireguardClientConnectError|undefined} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError} returns this
*/
proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError.prototype.setWireguard = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError.prototype.clearWireguard = function() {
  return this.setWireguard(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError.prototype.hasWireguard = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject.oneofGroups_ = [[1]];

/**
 * @enum {number}
 */
proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject.VPNConfigCase = {
  VPN_CONFIG_NOT_SET: 0,
  WIREGUARD: 1
};

/**
 * @return {proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject.VPNConfigCase}
 */
proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject.prototype.getVPNConfigCase = function() {
  return /** @type {proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject.VPNConfigCase} */(jspb.Message.computeOneofCase(this, proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject.toObject = function(includeInstance, msg) {
  var f, obj = {
    wireguard: (f = msg.getWireguard()) && proto.pangolin.protos.VPNServerWireguardServerConnectObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject}
 */
proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject;
  return proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject}
 */
proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.VPNServerWireguardServerConnectObject;
      reader.readMessage(value,proto.pangolin.protos.VPNServerWireguardServerConnectObject.deserializeBinaryFromReader);
      msg.setWireguard(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWireguard();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.VPNServerWireguardServerConnectObject.serializeBinaryToWriter
    );
  }
};


/**
 * optional VPNServerWireguardServerConnectObject wireguard = 1;
 * @return {?proto.pangolin.protos.VPNServerWireguardServerConnectObject}
 */
proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject.prototype.getWireguard = function() {
  return /** @type{?proto.pangolin.protos.VPNServerWireguardServerConnectObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.VPNServerWireguardServerConnectObject, 1));
};


/**
 * @param {?proto.pangolin.protos.VPNServerWireguardServerConnectObject|undefined} value
 * @return {!proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject} returns this
*/
proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject.prototype.setWireguard = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject.prototype.clearWireguard = function() {
  return this.setWireguard(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject.prototype.hasWireguard = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectObject.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerPangolinClientConnectObject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectObject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientConnectObject.toObject = function(includeInstance, msg) {
  var f, obj = {
    punchMode: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    vpnProto: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    netProto: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
    publicIp: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
    publicPort: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
    vpnConfig: (f = msg.getVPNConfig()) && proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectObject}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectObject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerPangolinClientConnectObject;
  return proto.pangolin.protos.VPNServerPangolinClientConnectObject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectObject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectObject}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectObject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.pangolin.protos.VPNServerPangolinPunchMode} */ (reader.readEnum());
      msg.setPunchMode(value);
      break;
    case 2:
      var value = /** @type {!proto.pangolin.protos.VPNServerPangolinVPNProtocol} */ (reader.readEnum());
      msg.setVPNProto(value);
      break;
    case 3:
      var value = /** @type {!proto.pangolin.protos.VPNServerPangolinNetworkProtocol} */ (reader.readEnum());
      msg.setNetProto(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPublicIp(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPublicPort(value);
      break;
    case 6:
      var value = new proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject;
      reader.readMessage(value,proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject.deserializeBinaryFromReader);
      msg.setVPNConfig(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectObject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerPangolinClientConnectObject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectObject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientConnectObject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!proto.pangolin.protos.VPNServerPangolinPunchMode} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = /** @type {!proto.pangolin.protos.VPNServerPangolinVPNProtocol} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = /** @type {!proto.pangolin.protos.VPNServerPangolinNetworkProtocol} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getVPNConfig();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject.serializeBinaryToWriter
    );
  }
};


/**
 * required VPNServerPangolinPunchMode punch_mode = 1;
 * @return {!proto.pangolin.protos.VPNServerPangolinPunchMode}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectObject.prototype.getPunchMode = function() {
  return /** @type {!proto.pangolin.protos.VPNServerPangolinPunchMode} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.pangolin.protos.VPNServerPangolinPunchMode} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectObject.prototype.setPunchMode = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectObject.prototype.clearPunchMode = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectObject.prototype.hasPunchMode = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * required VPNServerPangolinVPNProtocol vpn_proto = 2;
 * @return {!proto.pangolin.protos.VPNServerPangolinVPNProtocol}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectObject.prototype.getVPNProto = function() {
  return /** @type {!proto.pangolin.protos.VPNServerPangolinVPNProtocol} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.pangolin.protos.VPNServerPangolinVPNProtocol} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectObject.prototype.setVPNProto = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectObject.prototype.clearVPNProto = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectObject.prototype.hasVPNProto = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * required VPNServerPangolinNetworkProtocol net_proto = 3;
 * @return {!proto.pangolin.protos.VPNServerPangolinNetworkProtocol}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectObject.prototype.getNetProto = function() {
  return /** @type {!proto.pangolin.protos.VPNServerPangolinNetworkProtocol} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.pangolin.protos.VPNServerPangolinNetworkProtocol} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectObject.prototype.setNetProto = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectObject.prototype.clearNetProto = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectObject.prototype.hasNetProto = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * required string public_ip = 4;
 * @return {string}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectObject.prototype.getPublicIp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectObject.prototype.setPublicIp = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectObject.prototype.clearPublicIp = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectObject.prototype.hasPublicIp = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * required uint32 public_port = 5;
 * @return {number}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectObject.prototype.getPublicPort = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectObject.prototype.setPublicPort = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectObject.prototype.clearPublicPort = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectObject.prototype.hasPublicPort = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * required VPNServerPangolinClientConnectVPNConfigObject vpn_config = 6;
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectObject.prototype.getVPNConfig = function() {
  return /** @type{!proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject, 6, 1));
};


/**
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigObject} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectObject} returns this
*/
proto.pangolin.protos.VPNServerPangolinClientConnectObject.prototype.setVPNConfig = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectObject.prototype.clearVPNConfig = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectObject.prototype.hasVPNConfig = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pangolin.protos.VPNServerPangolinClientConnectError.repeatedFields_ = [1,2,3,4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectError.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerPangolinClientConnectError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientConnectError.toObject = function(includeInstance, msg) {
  var f, obj = {
    punchModeList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    vpnProtoList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    netProtoList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    publicIpList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    publicPortList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
    vpnConfig: (f = msg.getVPNConfig()) && proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectError}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerPangolinClientConnectError;
  return proto.pangolin.protos.VPNServerPangolinClientConnectError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectError}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addPunchMode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addVPNProto(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addNetProto(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addPublicIp(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addPublicPort(value);
      break;
    case 6:
      var value = new proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError;
      reader.readMessage(value,proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError.deserializeBinaryFromReader);
      msg.setVPNConfig(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerPangolinClientConnectError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientConnectError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPunchModeList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getVPNProtoList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getNetProtoList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getPublicIpList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getPublicPortList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getVPNConfig();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError.serializeBinaryToWriter
    );
  }
};


/**
 * repeated string punch_mode = 1;
 * @return {!Array<string>}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectError.prototype.getPunchModeList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectError} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectError.prototype.setPunchModeList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectError} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectError.prototype.addPunchMode = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectError} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectError.prototype.clearPunchModeList = function() {
  return this.setPunchModeList([]);
};


/**
 * repeated string vpn_proto = 2;
 * @return {!Array<string>}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectError.prototype.getVPNProtoList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectError} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectError.prototype.setVPNProtoList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectError} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectError.prototype.addVPNProto = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectError} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectError.prototype.clearVPNProtoList = function() {
  return this.setVPNProtoList([]);
};


/**
 * repeated string net_proto = 3;
 * @return {!Array<string>}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectError.prototype.getNetProtoList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectError} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectError.prototype.setNetProtoList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectError} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectError.prototype.addNetProto = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectError} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectError.prototype.clearNetProtoList = function() {
  return this.setNetProtoList([]);
};


/**
 * repeated string public_ip = 4;
 * @return {!Array<string>}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectError.prototype.getPublicIpList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectError} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectError.prototype.setPublicIpList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectError} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectError.prototype.addPublicIp = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectError} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectError.prototype.clearPublicIpList = function() {
  return this.setPublicIpList([]);
};


/**
 * repeated string public_port = 5;
 * @return {!Array<string>}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectError.prototype.getPublicPortList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectError} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectError.prototype.setPublicPortList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectError} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectError.prototype.addPublicPort = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectError} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectError.prototype.clearPublicPortList = function() {
  return this.setPublicPortList([]);
};


/**
 * optional VPNServerPangolinClientConnectVPNConfigError vpn_config = 6;
 * @return {?proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectError.prototype.getVPNConfig = function() {
  return /** @type{?proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError, 6));
};


/**
 * @param {?proto.pangolin.protos.VPNServerPangolinClientConnectVPNConfigError|undefined} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectError} returns this
*/
proto.pangolin.protos.VPNServerPangolinClientConnectError.prototype.setVPNConfig = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectError} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectError.prototype.clearVPNConfig = function() {
  return this.setVPNConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectError.prototype.hasVPNConfig = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerPangolinServerConnectObject.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerPangolinServerConnectObject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerPangolinServerConnectObject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinServerConnectObject.toObject = function(includeInstance, msg) {
  var f, obj = {
    punchMode: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    vpnProto: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    netProto: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
    publicIp: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
    publicPort: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
    vpnConfig: (f = msg.getVPNConfig()) && proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject.toObject(includeInstance, f),
    punchSecret: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerPangolinServerConnectObject}
 */
proto.pangolin.protos.VPNServerPangolinServerConnectObject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerPangolinServerConnectObject;
  return proto.pangolin.protos.VPNServerPangolinServerConnectObject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerPangolinServerConnectObject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerPangolinServerConnectObject}
 */
proto.pangolin.protos.VPNServerPangolinServerConnectObject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.pangolin.protos.VPNServerPangolinPunchMode} */ (reader.readEnum());
      msg.setPunchMode(value);
      break;
    case 2:
      var value = /** @type {!proto.pangolin.protos.VPNServerPangolinVPNProtocol} */ (reader.readEnum());
      msg.setVPNProto(value);
      break;
    case 3:
      var value = /** @type {!proto.pangolin.protos.VPNServerPangolinNetworkProtocol} */ (reader.readEnum());
      msg.setNetProto(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPublicIp(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPublicPort(value);
      break;
    case 6:
      var value = new proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject;
      reader.readMessage(value,proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject.deserializeBinaryFromReader);
      msg.setVPNConfig(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPunchSecret(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerPangolinServerConnectObject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerPangolinServerConnectObject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerPangolinServerConnectObject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinServerConnectObject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!proto.pangolin.protos.VPNServerPangolinPunchMode} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = /** @type {!proto.pangolin.protos.VPNServerPangolinVPNProtocol} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = /** @type {!proto.pangolin.protos.VPNServerPangolinNetworkProtocol} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getVPNConfig();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * required VPNServerPangolinPunchMode punch_mode = 1;
 * @return {!proto.pangolin.protos.VPNServerPangolinPunchMode}
 */
proto.pangolin.protos.VPNServerPangolinServerConnectObject.prototype.getPunchMode = function() {
  return /** @type {!proto.pangolin.protos.VPNServerPangolinPunchMode} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.pangolin.protos.VPNServerPangolinPunchMode} value
 * @return {!proto.pangolin.protos.VPNServerPangolinServerConnectObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinServerConnectObject.prototype.setPunchMode = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinServerConnectObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinServerConnectObject.prototype.clearPunchMode = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinServerConnectObject.prototype.hasPunchMode = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * required VPNServerPangolinVPNProtocol vpn_proto = 2;
 * @return {!proto.pangolin.protos.VPNServerPangolinVPNProtocol}
 */
proto.pangolin.protos.VPNServerPangolinServerConnectObject.prototype.getVPNProto = function() {
  return /** @type {!proto.pangolin.protos.VPNServerPangolinVPNProtocol} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.pangolin.protos.VPNServerPangolinVPNProtocol} value
 * @return {!proto.pangolin.protos.VPNServerPangolinServerConnectObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinServerConnectObject.prototype.setVPNProto = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinServerConnectObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinServerConnectObject.prototype.clearVPNProto = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinServerConnectObject.prototype.hasVPNProto = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * required VPNServerPangolinNetworkProtocol net_proto = 3;
 * @return {!proto.pangolin.protos.VPNServerPangolinNetworkProtocol}
 */
proto.pangolin.protos.VPNServerPangolinServerConnectObject.prototype.getNetProto = function() {
  return /** @type {!proto.pangolin.protos.VPNServerPangolinNetworkProtocol} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.pangolin.protos.VPNServerPangolinNetworkProtocol} value
 * @return {!proto.pangolin.protos.VPNServerPangolinServerConnectObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinServerConnectObject.prototype.setNetProto = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinServerConnectObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinServerConnectObject.prototype.clearNetProto = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinServerConnectObject.prototype.hasNetProto = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * required string public_ip = 4;
 * @return {string}
 */
proto.pangolin.protos.VPNServerPangolinServerConnectObject.prototype.getPublicIp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.VPNServerPangolinServerConnectObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinServerConnectObject.prototype.setPublicIp = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinServerConnectObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinServerConnectObject.prototype.clearPublicIp = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinServerConnectObject.prototype.hasPublicIp = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * required uint32 public_port = 5;
 * @return {number}
 */
proto.pangolin.protos.VPNServerPangolinServerConnectObject.prototype.getPublicPort = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.VPNServerPangolinServerConnectObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinServerConnectObject.prototype.setPublicPort = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinServerConnectObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinServerConnectObject.prototype.clearPublicPort = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinServerConnectObject.prototype.hasPublicPort = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * required VPNServerPangolinServerConnectVPNConfigObject vpn_config = 6;
 * @return {!proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject}
 */
proto.pangolin.protos.VPNServerPangolinServerConnectObject.prototype.getVPNConfig = function() {
  return /** @type{!proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject, 6, 1));
};


/**
 * @param {!proto.pangolin.protos.VPNServerPangolinServerConnectVPNConfigObject} value
 * @return {!proto.pangolin.protos.VPNServerPangolinServerConnectObject} returns this
*/
proto.pangolin.protos.VPNServerPangolinServerConnectObject.prototype.setVPNConfig = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinServerConnectObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinServerConnectObject.prototype.clearVPNConfig = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinServerConnectObject.prototype.hasVPNConfig = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * required string punch_secret = 7;
 * @return {string}
 */
proto.pangolin.protos.VPNServerPangolinServerConnectObject.prototype.getPunchSecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.VPNServerPangolinServerConnectObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinServerConnectObject.prototype.setPunchSecret = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinServerConnectObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinServerConnectObject.prototype.clearPunchSecret = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinServerConnectObject.prototype.hasPunchSecret = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedObject.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerPangolinClientConnectedObject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectedObject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedObject.toObject = function(includeInstance, msg) {
  var f, obj = {
    publicIp: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    publicPort: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectedObject}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedObject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerPangolinClientConnectedObject;
  return proto.pangolin.protos.VPNServerPangolinClientConnectedObject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectedObject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectedObject}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedObject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPublicIp(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPublicPort(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedObject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerPangolinClientConnectedObject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectedObject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedObject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeUint32(
      2,
      f
    );
  }
};


/**
 * required string public_ip = 1;
 * @return {string}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedObject.prototype.getPublicIp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectedObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedObject.prototype.setPublicIp = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectedObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedObject.prototype.clearPublicIp = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedObject.prototype.hasPublicIp = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * required uint32 public_port = 2;
 * @return {number}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedObject.prototype.getPublicPort = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectedObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedObject.prototype.setPublicPort = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectedObject} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedObject.prototype.clearPublicPort = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedObject.prototype.hasPublicPort = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedError.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedError.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerPangolinClientConnectedError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectedError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedError.toObject = function(includeInstance, msg) {
  var f, obj = {
    publicIpList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    publicPortList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectedError}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerPangolinClientConnectedError;
  return proto.pangolin.protos.VPNServerPangolinClientConnectedError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectedError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectedError}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addPublicIp(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addPublicPort(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerPangolinClientConnectedError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectedError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPublicIpList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getPublicPortList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * repeated string public_ip = 1;
 * @return {!Array<string>}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedError.prototype.getPublicIpList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectedError} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedError.prototype.setPublicIpList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectedError} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedError.prototype.addPublicIp = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectedError} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedError.prototype.clearPublicIpList = function() {
  return this.setPublicIpList([]);
};


/**
 * repeated string public_port = 2;
 * @return {!Array<string>}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedError.prototype.getPublicPortList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectedError} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedError.prototype.setPublicPortList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectedError} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedError.prototype.addPublicPort = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectedError} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedError.prototype.clearPublicPortList = function() {
  return this.setPublicPortList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerHedgehogClientListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerHedgehogClientListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerHedgehogClientListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerHedgehogClientListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    clients: (f = msg.getClients()) && proto.pangolin.protos.VPNServerHedgehogClientObjectMap.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientListResponse}
 */
proto.pangolin.protos.VPNServerHedgehogClientListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerHedgehogClientListResponse;
  return proto.pangolin.protos.VPNServerHedgehogClientListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerHedgehogClientListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientListResponse}
 */
proto.pangolin.protos.VPNServerHedgehogClientListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.VPNServerHedgehogClientObjectMap;
      reader.readMessage(value,proto.pangolin.protos.VPNServerHedgehogClientObjectMap.deserializeBinaryFromReader);
      msg.setClients(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerHedgehogClientListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerHedgehogClientListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerHedgehogClientListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerHedgehogClientListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClients();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.VPNServerHedgehogClientObjectMap.serializeBinaryToWriter
    );
  }
};


/**
 * required VPNServerHedgehogClientObjectMap clients = 1;
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientObjectMap}
 */
proto.pangolin.protos.VPNServerHedgehogClientListResponse.prototype.getClients = function() {
  return /** @type{!proto.pangolin.protos.VPNServerHedgehogClientObjectMap} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.VPNServerHedgehogClientObjectMap, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.VPNServerHedgehogClientObjectMap} value
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientListResponse} returns this
*/
proto.pangolin.protos.VPNServerHedgehogClientListResponse.prototype.setClients = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientListResponse} returns this
 */
proto.pangolin.protos.VPNServerHedgehogClientListResponse.prototype.clearClients = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerHedgehogClientListResponse.prototype.hasClients = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerHedgehogClientGetResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerHedgehogClientGetResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerHedgehogClientGetResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerHedgehogClientGetResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    client: (f = msg.getClient()) && proto.pangolin.protos.VPNServerHedgehogClientObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientGetResponse}
 */
proto.pangolin.protos.VPNServerHedgehogClientGetResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerHedgehogClientGetResponse;
  return proto.pangolin.protos.VPNServerHedgehogClientGetResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerHedgehogClientGetResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientGetResponse}
 */
proto.pangolin.protos.VPNServerHedgehogClientGetResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.VPNServerHedgehogClientObject;
      reader.readMessage(value,proto.pangolin.protos.VPNServerHedgehogClientObject.deserializeBinaryFromReader);
      msg.setClient(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerHedgehogClientGetResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerHedgehogClientGetResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerHedgehogClientGetResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerHedgehogClientGetResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClient();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.VPNServerHedgehogClientObject.serializeBinaryToWriter
    );
  }
};


/**
 * required VPNServerHedgehogClientObject client = 1;
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientObject}
 */
proto.pangolin.protos.VPNServerHedgehogClientGetResponse.prototype.getClient = function() {
  return /** @type{!proto.pangolin.protos.VPNServerHedgehogClientObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.VPNServerHedgehogClientObject, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.VPNServerHedgehogClientObject} value
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientGetResponse} returns this
*/
proto.pangolin.protos.VPNServerHedgehogClientGetResponse.prototype.setClient = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientGetResponse} returns this
 */
proto.pangolin.protos.VPNServerHedgehogClientGetResponse.prototype.clearClient = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerHedgehogClientGetResponse.prototype.hasClient = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerPangolinServerGetResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerPangolinServerGetResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerPangolinServerGetResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinServerGetResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    server: (f = msg.getServer()) && proto.pangolin.protos.VPNServerPangolinServerObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerPangolinServerGetResponse}
 */
proto.pangolin.protos.VPNServerPangolinServerGetResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerPangolinServerGetResponse;
  return proto.pangolin.protos.VPNServerPangolinServerGetResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerPangolinServerGetResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerPangolinServerGetResponse}
 */
proto.pangolin.protos.VPNServerPangolinServerGetResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.VPNServerPangolinServerObject;
      reader.readMessage(value,proto.pangolin.protos.VPNServerPangolinServerObject.deserializeBinaryFromReader);
      msg.setServer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerPangolinServerGetResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerPangolinServerGetResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerPangolinServerGetResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinServerGetResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServer();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.VPNServerPangolinServerObject.serializeBinaryToWriter
    );
  }
};


/**
 * required VPNServerPangolinServerObject server = 1;
 * @return {!proto.pangolin.protos.VPNServerPangolinServerObject}
 */
proto.pangolin.protos.VPNServerPangolinServerGetResponse.prototype.getServer = function() {
  return /** @type{!proto.pangolin.protos.VPNServerPangolinServerObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.VPNServerPangolinServerObject, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.VPNServerPangolinServerObject} value
 * @return {!proto.pangolin.protos.VPNServerPangolinServerGetResponse} returns this
*/
proto.pangolin.protos.VPNServerPangolinServerGetResponse.prototype.setServer = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinServerGetResponse} returns this
 */
proto.pangolin.protos.VPNServerPangolinServerGetResponse.prototype.clearServer = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinServerGetResponse.prototype.hasServer = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerPangolinServerSetRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerPangolinServerSetRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerPangolinServerSetRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinServerSetRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    server: (f = msg.getServer()) && proto.pangolin.protos.VPNServerPangolinServerObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerPangolinServerSetRequest}
 */
proto.pangolin.protos.VPNServerPangolinServerSetRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerPangolinServerSetRequest;
  return proto.pangolin.protos.VPNServerPangolinServerSetRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerPangolinServerSetRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerPangolinServerSetRequest}
 */
proto.pangolin.protos.VPNServerPangolinServerSetRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.VPNServerPangolinServerObject;
      reader.readMessage(value,proto.pangolin.protos.VPNServerPangolinServerObject.deserializeBinaryFromReader);
      msg.setServer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerPangolinServerSetRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerPangolinServerSetRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerPangolinServerSetRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinServerSetRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServer();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.VPNServerPangolinServerObject.serializeBinaryToWriter
    );
  }
};


/**
 * required VPNServerPangolinServerObject server = 1;
 * @return {!proto.pangolin.protos.VPNServerPangolinServerObject}
 */
proto.pangolin.protos.VPNServerPangolinServerSetRequest.prototype.getServer = function() {
  return /** @type{!proto.pangolin.protos.VPNServerPangolinServerObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.VPNServerPangolinServerObject, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.VPNServerPangolinServerObject} value
 * @return {!proto.pangolin.protos.VPNServerPangolinServerSetRequest} returns this
*/
proto.pangolin.protos.VPNServerPangolinServerSetRequest.prototype.setServer = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinServerSetRequest} returns this
 */
proto.pangolin.protos.VPNServerPangolinServerSetRequest.prototype.clearServer = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinServerSetRequest.prototype.hasServer = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerPangolinServerSetResponseInvalid.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerPangolinServerSetResponseInvalid.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerPangolinServerSetResponseInvalid} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinServerSetResponseInvalid.toObject = function(includeInstance, msg) {
  var f, obj = {
    server: (f = msg.getServer()) && proto.pangolin.protos.VPNServerPangolinServerError.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerPangolinServerSetResponseInvalid}
 */
proto.pangolin.protos.VPNServerPangolinServerSetResponseInvalid.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerPangolinServerSetResponseInvalid;
  return proto.pangolin.protos.VPNServerPangolinServerSetResponseInvalid.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerPangolinServerSetResponseInvalid} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerPangolinServerSetResponseInvalid}
 */
proto.pangolin.protos.VPNServerPangolinServerSetResponseInvalid.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.VPNServerPangolinServerError;
      reader.readMessage(value,proto.pangolin.protos.VPNServerPangolinServerError.deserializeBinaryFromReader);
      msg.setServer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerPangolinServerSetResponseInvalid.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerPangolinServerSetResponseInvalid.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerPangolinServerSetResponseInvalid} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinServerSetResponseInvalid.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServer();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.VPNServerPangolinServerError.serializeBinaryToWriter
    );
  }
};


/**
 * required VPNServerPangolinServerError server = 1;
 * @return {!proto.pangolin.protos.VPNServerPangolinServerError}
 */
proto.pangolin.protos.VPNServerPangolinServerSetResponseInvalid.prototype.getServer = function() {
  return /** @type{!proto.pangolin.protos.VPNServerPangolinServerError} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.VPNServerPangolinServerError, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.VPNServerPangolinServerError} value
 * @return {!proto.pangolin.protos.VPNServerPangolinServerSetResponseInvalid} returns this
*/
proto.pangolin.protos.VPNServerPangolinServerSetResponseInvalid.prototype.setServer = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinServerSetResponseInvalid} returns this
 */
proto.pangolin.protos.VPNServerPangolinServerSetResponseInvalid.prototype.clearServer = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinServerSetResponseInvalid.prototype.hasServer = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerPangolinClientListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerPangolinClientListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerPangolinClientListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    clients: (f = msg.getClients()) && proto.pangolin.protos.VPNServerPangolinClientObjectMap.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientListResponse}
 */
proto.pangolin.protos.VPNServerPangolinClientListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerPangolinClientListResponse;
  return proto.pangolin.protos.VPNServerPangolinClientListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientListResponse}
 */
proto.pangolin.protos.VPNServerPangolinClientListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.VPNServerPangolinClientObjectMap;
      reader.readMessage(value,proto.pangolin.protos.VPNServerPangolinClientObjectMap.deserializeBinaryFromReader);
      msg.setClients(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerPangolinClientListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerPangolinClientListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClients();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.VPNServerPangolinClientObjectMap.serializeBinaryToWriter
    );
  }
};


/**
 * required VPNServerPangolinClientObjectMap clients = 1;
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObjectMap}
 */
proto.pangolin.protos.VPNServerPangolinClientListResponse.prototype.getClients = function() {
  return /** @type{!proto.pangolin.protos.VPNServerPangolinClientObjectMap} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.VPNServerPangolinClientObjectMap, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.VPNServerPangolinClientObjectMap} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientListResponse} returns this
*/
proto.pangolin.protos.VPNServerPangolinClientListResponse.prototype.setClients = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientListResponse} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientListResponse.prototype.clearClients = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinClientListResponse.prototype.hasClients = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerPangolinClientGetResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerPangolinClientGetResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerPangolinClientGetResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientGetResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    client: (f = msg.getClient()) && proto.pangolin.protos.VPNServerPangolinClientObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientGetResponse}
 */
proto.pangolin.protos.VPNServerPangolinClientGetResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerPangolinClientGetResponse;
  return proto.pangolin.protos.VPNServerPangolinClientGetResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientGetResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientGetResponse}
 */
proto.pangolin.protos.VPNServerPangolinClientGetResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.VPNServerPangolinClientObject;
      reader.readMessage(value,proto.pangolin.protos.VPNServerPangolinClientObject.deserializeBinaryFromReader);
      msg.setClient(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerPangolinClientGetResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerPangolinClientGetResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientGetResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientGetResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClient();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.VPNServerPangolinClientObject.serializeBinaryToWriter
    );
  }
};


/**
 * required VPNServerPangolinClientObject client = 1;
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObject}
 */
proto.pangolin.protos.VPNServerPangolinClientGetResponse.prototype.getClient = function() {
  return /** @type{!proto.pangolin.protos.VPNServerPangolinClientObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.VPNServerPangolinClientObject, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.VPNServerPangolinClientObject} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientGetResponse} returns this
*/
proto.pangolin.protos.VPNServerPangolinClientGetResponse.prototype.setClient = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientGetResponse} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientGetResponse.prototype.clearClient = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinClientGetResponse.prototype.hasClient = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerPangolinClientCreateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerPangolinClientCreateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerPangolinClientCreateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientCreateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    client: (f = msg.getClient()) && proto.pangolin.protos.VPNServerHedgehogClientObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientCreateRequest}
 */
proto.pangolin.protos.VPNServerPangolinClientCreateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerPangolinClientCreateRequest;
  return proto.pangolin.protos.VPNServerPangolinClientCreateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientCreateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientCreateRequest}
 */
proto.pangolin.protos.VPNServerPangolinClientCreateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.VPNServerHedgehogClientObject;
      reader.readMessage(value,proto.pangolin.protos.VPNServerHedgehogClientObject.deserializeBinaryFromReader);
      msg.setClient(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerPangolinClientCreateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerPangolinClientCreateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientCreateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientCreateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClient();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.VPNServerHedgehogClientObject.serializeBinaryToWriter
    );
  }
};


/**
 * required VPNServerHedgehogClientObject client = 1;
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientObject}
 */
proto.pangolin.protos.VPNServerPangolinClientCreateRequest.prototype.getClient = function() {
  return /** @type{!proto.pangolin.protos.VPNServerHedgehogClientObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.VPNServerHedgehogClientObject, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.VPNServerHedgehogClientObject} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientCreateRequest} returns this
*/
proto.pangolin.protos.VPNServerPangolinClientCreateRequest.prototype.setClient = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientCreateRequest} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientCreateRequest.prototype.clearClient = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinClientCreateRequest.prototype.hasClient = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerPangolinClientCreateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerPangolinClientCreateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerPangolinClientCreateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientCreateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    client: (f = msg.getClient()) && proto.pangolin.protos.VPNServerPangolinClientObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientCreateResponse}
 */
proto.pangolin.protos.VPNServerPangolinClientCreateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerPangolinClientCreateResponse;
  return proto.pangolin.protos.VPNServerPangolinClientCreateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientCreateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientCreateResponse}
 */
proto.pangolin.protos.VPNServerPangolinClientCreateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.VPNServerPangolinClientObject;
      reader.readMessage(value,proto.pangolin.protos.VPNServerPangolinClientObject.deserializeBinaryFromReader);
      msg.setClient(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerPangolinClientCreateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerPangolinClientCreateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientCreateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientCreateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClient();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.VPNServerPangolinClientObject.serializeBinaryToWriter
    );
  }
};


/**
 * required VPNServerPangolinClientObject client = 1;
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObject}
 */
proto.pangolin.protos.VPNServerPangolinClientCreateResponse.prototype.getClient = function() {
  return /** @type{!proto.pangolin.protos.VPNServerPangolinClientObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.VPNServerPangolinClientObject, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.VPNServerPangolinClientObject} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientCreateResponse} returns this
*/
proto.pangolin.protos.VPNServerPangolinClientCreateResponse.prototype.setClient = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientCreateResponse} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientCreateResponse.prototype.clearClient = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinClientCreateResponse.prototype.hasClient = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerPangolinClientUpdateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerPangolinClientUpdateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerPangolinClientUpdateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientUpdateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    client: (f = msg.getClient()) && proto.pangolin.protos.VPNServerHedgehogClientObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientUpdateRequest}
 */
proto.pangolin.protos.VPNServerPangolinClientUpdateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerPangolinClientUpdateRequest;
  return proto.pangolin.protos.VPNServerPangolinClientUpdateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientUpdateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientUpdateRequest}
 */
proto.pangolin.protos.VPNServerPangolinClientUpdateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.VPNServerHedgehogClientObject;
      reader.readMessage(value,proto.pangolin.protos.VPNServerHedgehogClientObject.deserializeBinaryFromReader);
      msg.setClient(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerPangolinClientUpdateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerPangolinClientUpdateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientUpdateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientUpdateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClient();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.VPNServerHedgehogClientObject.serializeBinaryToWriter
    );
  }
};


/**
 * required VPNServerHedgehogClientObject client = 1;
 * @return {!proto.pangolin.protos.VPNServerHedgehogClientObject}
 */
proto.pangolin.protos.VPNServerPangolinClientUpdateRequest.prototype.getClient = function() {
  return /** @type{!proto.pangolin.protos.VPNServerHedgehogClientObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.VPNServerHedgehogClientObject, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.VPNServerHedgehogClientObject} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientUpdateRequest} returns this
*/
proto.pangolin.protos.VPNServerPangolinClientUpdateRequest.prototype.setClient = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientUpdateRequest} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientUpdateRequest.prototype.clearClient = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinClientUpdateRequest.prototype.hasClient = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerPangolinClientUpdateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerPangolinClientUpdateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerPangolinClientUpdateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientUpdateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    client: (f = msg.getClient()) && proto.pangolin.protos.VPNServerPangolinClientObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientUpdateResponse}
 */
proto.pangolin.protos.VPNServerPangolinClientUpdateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerPangolinClientUpdateResponse;
  return proto.pangolin.protos.VPNServerPangolinClientUpdateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientUpdateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientUpdateResponse}
 */
proto.pangolin.protos.VPNServerPangolinClientUpdateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.VPNServerPangolinClientObject;
      reader.readMessage(value,proto.pangolin.protos.VPNServerPangolinClientObject.deserializeBinaryFromReader);
      msg.setClient(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerPangolinClientUpdateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerPangolinClientUpdateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientUpdateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientUpdateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClient();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.VPNServerPangolinClientObject.serializeBinaryToWriter
    );
  }
};


/**
 * required VPNServerPangolinClientObject client = 1;
 * @return {!proto.pangolin.protos.VPNServerPangolinClientObject}
 */
proto.pangolin.protos.VPNServerPangolinClientUpdateResponse.prototype.getClient = function() {
  return /** @type{!proto.pangolin.protos.VPNServerPangolinClientObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.VPNServerPangolinClientObject, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.VPNServerPangolinClientObject} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientUpdateResponse} returns this
*/
proto.pangolin.protos.VPNServerPangolinClientUpdateResponse.prototype.setClient = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientUpdateResponse} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientUpdateResponse.prototype.clearClient = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinClientUpdateResponse.prototype.hasClient = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerPangolinClientConnectRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientConnectRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    client: (f = msg.getClient()) && proto.pangolin.protos.VPNServerPangolinClientConnectObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectRequest}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerPangolinClientConnectRequest;
  return proto.pangolin.protos.VPNServerPangolinClientConnectRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectRequest}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.VPNServerPangolinClientConnectObject;
      reader.readMessage(value,proto.pangolin.protos.VPNServerPangolinClientConnectObject.deserializeBinaryFromReader);
      msg.setClient(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerPangolinClientConnectRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientConnectRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClient();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.VPNServerPangolinClientConnectObject.serializeBinaryToWriter
    );
  }
};


/**
 * required VPNServerPangolinClientConnectObject client = 1;
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectObject}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectRequest.prototype.getClient = function() {
  return /** @type{!proto.pangolin.protos.VPNServerPangolinClientConnectObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.VPNServerPangolinClientConnectObject, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectObject} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectRequest} returns this
*/
proto.pangolin.protos.VPNServerPangolinClientConnectRequest.prototype.setClient = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectRequest} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectRequest.prototype.clearClient = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectRequest.prototype.hasClient = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerPangolinClientConnectResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientConnectResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    server: (f = msg.getServer()) && proto.pangolin.protos.VPNServerPangolinServerConnectObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectResponse}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerPangolinClientConnectResponse;
  return proto.pangolin.protos.VPNServerPangolinClientConnectResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectResponse}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.VPNServerPangolinServerConnectObject;
      reader.readMessage(value,proto.pangolin.protos.VPNServerPangolinServerConnectObject.deserializeBinaryFromReader);
      msg.setServer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerPangolinClientConnectResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientConnectResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServer();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.VPNServerPangolinServerConnectObject.serializeBinaryToWriter
    );
  }
};


/**
 * required VPNServerPangolinServerConnectObject server = 1;
 * @return {!proto.pangolin.protos.VPNServerPangolinServerConnectObject}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectResponse.prototype.getServer = function() {
  return /** @type{!proto.pangolin.protos.VPNServerPangolinServerConnectObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.VPNServerPangolinServerConnectObject, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.VPNServerPangolinServerConnectObject} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectResponse} returns this
*/
proto.pangolin.protos.VPNServerPangolinClientConnectResponse.prototype.setServer = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectResponse} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectResponse.prototype.clearServer = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectResponse.prototype.hasServer = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectResponseInvalid.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerPangolinClientConnectResponseInvalid.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectResponseInvalid} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientConnectResponseInvalid.toObject = function(includeInstance, msg) {
  var f, obj = {
    client: (f = msg.getClient()) && proto.pangolin.protos.VPNServerPangolinClientConnectError.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectResponseInvalid}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectResponseInvalid.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerPangolinClientConnectResponseInvalid;
  return proto.pangolin.protos.VPNServerPangolinClientConnectResponseInvalid.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectResponseInvalid} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectResponseInvalid}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectResponseInvalid.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.VPNServerPangolinClientConnectError;
      reader.readMessage(value,proto.pangolin.protos.VPNServerPangolinClientConnectError.deserializeBinaryFromReader);
      msg.setClient(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectResponseInvalid.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerPangolinClientConnectResponseInvalid.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectResponseInvalid} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientConnectResponseInvalid.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClient();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.VPNServerPangolinClientConnectError.serializeBinaryToWriter
    );
  }
};


/**
 * required VPNServerPangolinClientConnectError client = 1;
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectError}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectResponseInvalid.prototype.getClient = function() {
  return /** @type{!proto.pangolin.protos.VPNServerPangolinClientConnectError} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.VPNServerPangolinClientConnectError, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectError} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectResponseInvalid} returns this
*/
proto.pangolin.protos.VPNServerPangolinClientConnectResponseInvalid.prototype.setClient = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectResponseInvalid} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectResponseInvalid.prototype.clearClient = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectResponseInvalid.prototype.hasClient = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerPangolinClientConnectedRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectedRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    client: (f = msg.getClient()) && proto.pangolin.protos.VPNServerPangolinClientConnectedObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectedRequest}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerPangolinClientConnectedRequest;
  return proto.pangolin.protos.VPNServerPangolinClientConnectedRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectedRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectedRequest}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.VPNServerPangolinClientConnectedObject;
      reader.readMessage(value,proto.pangolin.protos.VPNServerPangolinClientConnectedObject.deserializeBinaryFromReader);
      msg.setClient(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerPangolinClientConnectedRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectedRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClient();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.VPNServerPangolinClientConnectedObject.serializeBinaryToWriter
    );
  }
};


/**
 * required VPNServerPangolinClientConnectedObject client = 1;
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectedObject}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedRequest.prototype.getClient = function() {
  return /** @type{!proto.pangolin.protos.VPNServerPangolinClientConnectedObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.VPNServerPangolinClientConnectedObject, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectedObject} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectedRequest} returns this
*/
proto.pangolin.protos.VPNServerPangolinClientConnectedRequest.prototype.setClient = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectedRequest} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedRequest.prototype.clearClient = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedRequest.prototype.hasClient = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedResponseInvalid.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.VPNServerPangolinClientConnectedResponseInvalid.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectedResponseInvalid} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedResponseInvalid.toObject = function(includeInstance, msg) {
  var f, obj = {
    client: (f = msg.getClient()) && proto.pangolin.protos.VPNServerPangolinClientConnectedError.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectedResponseInvalid}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedResponseInvalid.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.VPNServerPangolinClientConnectedResponseInvalid;
  return proto.pangolin.protos.VPNServerPangolinClientConnectedResponseInvalid.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectedResponseInvalid} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectedResponseInvalid}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedResponseInvalid.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.VPNServerPangolinClientConnectedError;
      reader.readMessage(value,proto.pangolin.protos.VPNServerPangolinClientConnectedError.deserializeBinaryFromReader);
      msg.setClient(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedResponseInvalid.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.VPNServerPangolinClientConnectedResponseInvalid.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectedResponseInvalid} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedResponseInvalid.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClient();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.VPNServerPangolinClientConnectedError.serializeBinaryToWriter
    );
  }
};


/**
 * required VPNServerPangolinClientConnectedError client = 1;
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectedError}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedResponseInvalid.prototype.getClient = function() {
  return /** @type{!proto.pangolin.protos.VPNServerPangolinClientConnectedError} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.VPNServerPangolinClientConnectedError, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.VPNServerPangolinClientConnectedError} value
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectedResponseInvalid} returns this
*/
proto.pangolin.protos.VPNServerPangolinClientConnectedResponseInvalid.prototype.setClient = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.VPNServerPangolinClientConnectedResponseInvalid} returns this
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedResponseInvalid.prototype.clearClient = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.VPNServerPangolinClientConnectedResponseInvalid.prototype.hasClient = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * @enum {number}
 */
proto.pangolin.protos.VPNServerPangolinPunchMode = {
  VPNSERVER_PANGOLIN_PUNCH_MODE_UNSET: 0,
  VPNSERVER_PANGOLIN_PUNCH_MODE_CONSTANT: 1,
  VPNSERVER_PANGOLIN_PUNCH_MODE_ASCENDING: 2,
  VPNSERVER_PANGOLIN_PUNCH_MODE_DESCENDING: 3,
  VPNSERVER_PANGOLIN_PUNCH_MODE_RANDOM: 4
};

/**
 * @enum {number}
 */
proto.pangolin.protos.VPNServerPangolinVPNProtocol = {
  VPNSERVER_PANGOLIN_VPN_PROTO_UNSET: 0,
  VPNSERVER_PANGOLIN_VPN_PROTO_WIREGUARD: 1
};

/**
 * @enum {number}
 */
proto.pangolin.protos.VPNServerPangolinNetworkProtocol = {
  VPNSERVER_PANGOLIN_NET_PROTO_UNSET: 0,
  VPNSERVER_PANGOLIN_NET_PROTO_TCP: 6,
  VPNSERVER_PANGOLIN_NET_PROTO_UDP: 17
};

/**
 * @enum {number}
 */
proto.pangolin.protos.VPNServerPangolinStatus = {
  VPNSERVER_PANGOLIN_STATUS_OFFLINE: 0,
  VPNSERVER_PANGOLIN_STATUS_ONLINE: 1
};

goog.object.extend(exports, proto.pangolin.protos);
